import axios from 'axios';
import api from './axiosClient';

// Export axios client explicitly so all hooks can import { axiosApi } consistently.
export const axiosApi = api;

// Normalize base
const RAW_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';
const API_BASE = RAW_BASE.replace(/\/+$/, '');

// Helper: if url starts with http://localhost or http://127.0.0.1, rewrite to API_BASE
function rewriteUrl(url) {
  if (typeof url !== 'string') return url;
  const localhostPatterns = [/^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?/i];
  for (const p of localhostPatterns) {
    if (p.test(url)) {
      // replace origin with API_BASE
      try {
        const u = new URL(url);
        const path = u.pathname + u.search + u.hash;
        return `${API_BASE}${path}`;
      } catch (e) {
        // fallback simple replace
        return url.replace(p, API_BASE);
      }
    }
  }
  return url;
}

// Patch global fetch to rewrite localhost requests to API_BASE
if (typeof window !== 'undefined' && window.fetch) {
  const originalFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    try {
      if (typeof input === 'string') {
        input = rewriteUrl(input);
      } else if (input && input.url) {
        input = new Request(rewriteUrl(input.url), input);
      }
    } catch (e) {
      // noop - fallback to original
    }
    return originalFetch(input, init);
  };
}

// For axios instances that use full urls, intercept and rewrite
// Apply to global axios as a fallback
axios.interceptors.request.use((config) => {
  if (config && config.url && typeof config.url === 'string') {
    // if url is absolute localhost, rewrite
    if (/^https?:\/\/(localhost|127\.0\.0\.1)/i.test(config.url)) {
      config.url = rewriteUrl(config.url);
      // If baseURL is set, axios will join them; ensure we keep absolute
      config.baseURL = '';
    }
  }
  return config;
});

export { rewriteUrl };
